import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";

const Protected = ({ children, adminOnly = false }) => {
    const { user, loading } = useAuth();
    if (loading) return (
        <div className="min-h-screen grid place-items-center bg-obsidian text-ivory">
            <div className="w-10 h-10 rounded-full border-2 border-gold border-t-transparent animate-spin" />
        </div>
    );
    if (!user) return <Navigate to="/" replace />;
    if (adminOnly && user.role !== "admin" && user.role !== "staff") return <Navigate to="/dashboard" replace />;
    return children;
};

function AppRouter() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRouter />
            </AuthProvider>
        </BrowserRouter>
    );
}
